import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import VerificationTypeModalComponent from './VerificationTypeModalComponent';
import { emptyArray } from 'utils/constants';
import { TEST_VERIFICATION_FORMULA } from '../../edit/mutations';
import { useQuery, useMutation, useSubscription } from 'hooks/apollo';
import { useToast } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { DOCUMENT_TYPES_QUERY } from '../../edit/queries';
import { useValidation } from '@totalsoft/pure-validations-react';
import { required, shape } from '@totalsoft/pure-validations';
import { TEST_FORMULA_VERIFICATION_FAILED, VERIFICATION_FORMULA_GENERATED } from '../../edit/subscriptions';

const VerificationTypeModalContainer = ({ onToggleModal, title, onCloseModal }) => {
  const [verificationTestResult, setVerificationTestResult] = useState(emptyArray);
  const [documentTypes, setDocumentTypes] = useState([]);
  const verificationTypeId = null;

  const [t] = useTranslation();
  const addToast = useToast();

  const [localState, setLocalState] = useState({
    documentNumber: undefined,
    documentTypeId: undefined
  });

  const validator = shape({
    documentNumber: required,
    documentTypeId: required
  });

  const [conditionValidateTesting, validateConditionTesting] = useValidation(validator);

  useQuery(DOCUMENT_TYPES_QUERY, {
    onCompleted: data => {
      setDocumentTypes(data.documentTypes);
    }
  });

  const [testVerificationFormula] = useMutation(TEST_VERIFICATION_FORMULA);

  useSubscription(TEST_FORMULA_VERIFICATION_FAILED, {
    onData: ({ data }) => {
      addToast(data.data.testFormulaVerificationFailed.errorMessage, 'error');
    }
  });

  useSubscription(VERIFICATION_FORMULA_GENERATED, {
    onData: ({ data: { data } }) => {
      const verificationType = data.verificationFormulaGenerated.verificationFormulas;
      setVerificationTestResult(verificationType);
      addToast(t('VerificationTypes.VerificationTestGenerated'), 'success');
    }
  });

  const handlePropertyChange = (propName, propValue) => {
    setLocalState(prevState => ({ ...prevState, [propName]: propValue }));
    setVerificationTestResult(emptyArray);
  };

  useEffect(() => {
    validateConditionTesting(localState);
  }, [localState, validateConditionTesting]);

  const handleVerificationClickTest = useCallback(() => {
    const input = {
      verificationTypeId,
      documentNumber: localState.documentNumber,
      documentTypeId: localState.documentTypeId
    };
    if (!validateConditionTesting(input)) return;
    setLocalState(prevState => ({ ...prevState, canTestVerification: true }));
    testVerificationFormula({
      variables: { input }
    });
  }, [verificationTypeId, localState.documentNumber, localState.documentTypeId, validateConditionTesting, testVerificationFormula]);

  return (
    <VerificationTypeModalComponent
      onToggleModal={onToggleModal}
      title={title}
      onCloseModal={onCloseModal}
      verificationTestResponse={verificationTestResult}
      onPropertyChange={handlePropertyChange}
      documentTypes={documentTypes}
      onVerificationClickTest={handleVerificationClickTest}
      documentTypeId={localState.documentTypeId}
      documentNumber={localState.documentNumber}
      validation={conditionValidateTesting}
    />
  );
};

VerificationTypeModalContainer.propTypes = {
  onToggleModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  verificationTestResponse: PropTypes.array.isRequired
};
export default VerificationTypeModalContainer;
